var Country;
(function (Country) {
    Country[Country["Common"] = 0] = "Common";
    Country[Country["Norway"] = 1] = "Norway";
    Country[Country["Denmark"] = 2] = "Denmark";
    Country[Country["Sweden"] = 3] = "Sweden";
    Country[Country["Finland"] = 4] = "Finland";
    Country[Country["Baltics"] = 5] = "Baltics";
    Country[Country["Test"] = 6] = "Test";
    Country[Country["Nordic"] = 7] = "Nordic";
    Country[Country["UserTest"] = 100] = "UserTest";
})(Country || (Country = {}));
export default Country;
//# sourceMappingURL=country.js.map